import { MessageSquare, PlayCircle } from 'lucide-react';
import { MarketingHeroPill } from '@/components/marketing/v2/MarketingHeroPill';
import { NeobrutalButton } from '@/components/marketing/v2/NeobrutalButton';

function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export default function DemoHeroV2() {
  return (
    <section className="bg-paper pb-16 pt-16 md:pb-20 md:pt-20">
      <div className="mx-auto max-w-5xl px-6 text-center md:px-8">
        <MarketingHeroPill>Démo Velko · sans engagement</MarketingHeroPill>

        <h1 className="mx-auto mt-7 max-w-4xl font-marketing-display text-[clamp(40px,7vw,88px)] font-bold leading-[0.95] tracking-[-0.045em] text-charcoal-800">
          Voyez Velko <span className="underline-lime">en 10 minutes.</span>
        </h1>

        <p className="mx-auto mt-7 max-w-2xl font-marketing-body text-lg leading-[1.55] text-charcoal-600 md:text-xl">
          Regarde une vidéo de démo module par module, ou parle directement à l'équipe pour une
          démo live sur WhatsApp ou en visio — avec ton propre catalogue si tu veux.
        </p>

        <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
          <NeobrutalButton
            as="button"
            variant="primary"
            size="lg"
            onClick={() => scrollToId('videos')}
          >
            <PlayCircle className="h-5 w-5" strokeWidth={2.3} />
            Voir les vidéos
          </NeobrutalButton>
          <NeobrutalButton
            as="button"
            variant="secondary"
            size="lg"
            onClick={() => scrollToId('formulaire')}
          >
            <MessageSquare className="h-5 w-5" strokeWidth={2.3} />
            Demander une démo live
          </NeobrutalButton>
        </div>
      </div>
    </section>
  );
}
